"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = Sidebar;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `Sidebar` layout component is named for the element that forms the diminutive sidebar: the
 * narrower of two adjacent elements. It is a quantum layout, existing simultaneously in one of the
 * two configurations—horizontal and vertical. Which configuration is adopted is not known at the
 * time of conception, and is dependent entirely on the space it is afforded when placed within a
 * parent container.
 */
function Sidebar({
  testId,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledSidebar, _extends({
    "data-testid": testId
  }, props));
}